import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { theme } from '../../theme';
import { useApi } from '../../hooks/useApi';

export function MyPageScreen({ onNavigate }) {
  const { isAuthenticated, user, login, logout } = useAuth();
  const api = useApi();
  const [profile, setProfile] = useState(null);
  const [synced, setSynced] = useState(false);

  // Sync user to D1 on first authenticated visit
  useEffect(() => {
    if (!isAuthenticated || !user?.email || synced) return;
    let cancelled = false;
    async function syncUser() {
      try {
        const res = await api.auth.sync();
        if (!cancelled) {
          setProfile(res.data || res);
          setSynced(true);
        }
      } catch (err) {
        console.error('Auth sync error:', err);
        if (!cancelled) setSynced(true);
      }
    }
    syncUser();
    return () => { cancelled = true; };
  }, [isAuthenticated, user?.email]);

  if (!isAuthenticated) {
    return (
      <div style={{ padding: '16px', textAlign: 'center', marginTop: '40px' }}>
        <p style={{ fontSize: '48px', marginBottom: '16px' }}>👤</p>
        <h2 style={{ color: theme.text, marginBottom: '8px' }}>Skráðu þig inn</h2>
        <p style={{ color: theme.textSecondary, fontSize: '14px', marginBottom: '16px' }}>
          Til að sjá þínar beiðnir, pantanir og maker prófíl
        </p>
        <button
          onClick={() => login()}
          style={{
            background: theme.accent,
            color: '#000',
            border: 'none',
            padding: '12px 32px',
            borderRadius: theme.radiusSm,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Innskrá með Google
        </button>
      </div>
    );
  }

  const isMaker = profile?.maker_id || profile?.makerId;

  return (
    <div style={{ padding: '16px' }}>
      {/* Profile Card */}
      <div style={{
        background: theme.bgCard,
        border: `1px solid ${theme.border}`,
        borderRadius: theme.radius,
        padding: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        marginBottom: '16px',
      }}>
        <img
          src={user?.picture}
          alt=""
          style={{ width: '56px', height: '56px', borderRadius: '50%' }}
        />
        <div>
          <h2 style={{ fontSize: '18px', fontWeight: 700, color: theme.text }}>{user?.name}</h2>
          <p style={{ fontSize: '13px', color: theme.textSecondary }}>{user?.email}</p>
          {isMaker && (
            <span style={{
              fontSize: '11px',
              padding: '2px 8px',
              borderRadius: '8px',
              background: theme.accentBg,
              color: theme.accent,
              fontWeight: 600,
              marginTop: '4px',
              display: 'inline-block',
            }}>
              Maker
            </span>
          )}
        </div>
      </div>

      {/* Quick Actions */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '24px' }}>
        {[
          { icon: '📋', label: 'Mínar beiðnir', action: () => onNavigate('browse') },
          { icon: '📦', label: 'Mínar pantanir', action: () => onNavigate('orders') },
          ...(isMaker
            ? [{ icon: '🔧', label: 'Maker prófíll', action: () => onNavigate('maker-profile', isMaker) }]
            : [{ icon: '🔧', label: 'Verða maker', action: () => onNavigate('maker-register') }]
          ),
          { icon: '⚙️', label: 'Stillingar', action: () => onNavigate('settings') },
        ].map(item => (
          <button
            key={item.label}
            onClick={item.action}
            style={{
              background: theme.bgCard,
              border: `1px solid ${theme.border}`,
              borderRadius: theme.radius,
              padding: '14px 16px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              cursor: 'pointer',
              textAlign: 'left',
              width: '100%',
            }}
          >
            <span style={{ fontSize: '20px' }}>{item.icon}</span>
            <span style={{ fontSize: '15px', color: theme.text, fontWeight: 500 }}>{item.label}</span>
          </button>
        ))}
      </div>

      {/* Logout */}
      <button
        onClick={() => logout()}
        style={{
          width: '100%',
          padding: '12px',
          background: 'transparent',
          border: `1px solid ${theme.error}`,
          borderRadius: theme.radiusSm,
          color: theme.error,
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Útskrá
      </button>
    </div>
  );
}
